import { Component, ViewEncapsulation, AfterViewInit, ElementRef, ViewChild, Input, EventEmitter, Output } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ForgotPasswordService } from '../forgot-password.service';
import { AuthResponseCode } from '../../constants/auth-response-code.enum';
import { RequestPasswordReset } from '../models/request-password-reset.model';

@Component({
  selector: 'app-request-password-reset',
  templateUrl: './request-password-reset.component.html',
  styleUrls: ['./request-password-reset.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class RequestPasswordResetComponent implements AfterViewInit {
  @Input() email: string;
  @Input() isAdmin = false;
  @Output() emailSent = new EventEmitter<RequestPasswordReset>();

  public form: FormGroup;
  @ViewChild("emailAddress") emailAddressRef : ElementRef;

  public emailAddress: AbstractControl;

  public isLoading = false;

  public errorMessage = '';
  public message = '';

  ngAfterViewInit() {
    document.getElementById('preloader').classList.add('hide');
    this.emailAddress.setValue(this.email);
  }

  constructor(
    private fb: FormBuilder,
    private passwordResetService: ForgotPasswordService,
  ) {
    this.form = this.fb.group({
      'emailAddress': ['', Validators.compose([Validators.required, Validators.email])],
    });

    this.emailAddress = this.form.controls['emailAddress'];
  }

  public async onSubmit(): Promise<void> {
    this.errorMessage = '';
    this.message = '';

    if (!this.form.valid) {
      this.errorMessage = "Please enter a valid email address.";
      return;
    }

    this.isLoading = true;

    const model: RequestPasswordReset = {
      email: this.emailAddress.value,
    };

    try {
      const response = await this.passwordResetService.requestPasswordReset(model);

      switch(response) {
        case AuthResponseCode.PASSWORD_RESET_EMAIL_SENT:
          this.emailSent.emit(model);
          break;
        default:
          this.errorMessage = "An error occurred. Please try again.";
          break;
      }
    } catch(error) {
      this.errorMessage = "An error occurred. Please try again.";
    } finally {
      this.isLoading = false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/auth/forgot-password/request-password-reset/request-password-reset.component.ts